import React from 'react';
import classNames from 'classnames';
import cls from './TableRowReconciliation.module.css';
import { useTableRowReconciliation } from './useTableRowReconciliation';

interface TableRowReconciliationProps {
    classes?: string;
    title: string;
    contractPrice: number;
    orderSum: number;
    customerPayment: number;
    customerBePaid: number;
    currencyCode: string;
}

export const TableRowReconciliation = ({
    classes,
    title,
    contractPrice,
    orderSum,
    customerBePaid,
    customerPayment,
    currencyCode,
}: TableRowReconciliationProps) => {
    const {} = useTableRowReconciliation();
    return (
        <div className={classNames(cls.TableRowReconciliation, [classes])}>
            <div className={classNames(cls.TableColumn, cls.TableColumnTitle)}>{title}</div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>{contractPrice}</div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>{orderSum}</div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>
                {customerBePaid}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>
                {customerPayment}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>{currencyCode}</div>
        </div>
    );
};
